import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    delay: {
      type: Number,
      default: 1000,
    },
  };

  connect() {
    this.isSubmitting = false;
    this.element.addEventListener("submit", () => {
      this.isSubmitting = true;
      clearTimeout(this.timer);
      // Reset flag after submission completes
      setTimeout(() => (this.isSubmitting = false), 100);
    });
  }

  submit() {
    if (this.isSubmitting) return;

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (!this.isSubmitting) {
        this.element.requestSubmit();
      }
    }, this.delayValue);
  }
}
